export const SignUpAnalytics = {
    default: {
        personalData: {
            onOpen: {
                event: 'nav_signup_funnel',
                funnel: { current_step: 'Formulário de cadastro', name: 'cadastro_web' },
                user: { has_mdm: undefined },
            },
            onFieldBlur: ({ fieldName, errorMessage, name }: { name?: string; fieldName?: string; errorMessage?: string }) => ({
                event: 'nav_signup_form_feedback',
                funnel: { current_step: 'Formulário de cadastro', name: name },
                field_name: fieldName,
                user: { has_mdm: undefined },
                feedback_message: errorMessage || 'Ok',
            }),
        },
        password: {
            onOpen: (name?: string) => ({
                event: 'nav_signup_funnel',
                funnel: { current_step: 'Crie uma senha', name: name || 'cadastro_web' },
                user: { has_mdm: undefined },
            }),
            onFieldBlur: ({
                errorMessage,
                password_is_valid,
                funnelCurrentStep,
                passwordAttributes,
                name,
            }: {
                errorMessage?: string
                password_is_valid?: boolean
                funnelCurrentStep?: string
                passwordAttributes?: string
                name?: string
            }) => ({
                event: 'nav_password_creation_feedback',
                funnel: { current_step: funnelCurrentStep, name: name },
                feedback_message: errorMessage || 'Ok',
                password_is_valid,
                password_attributes: passwordAttributes,
            }),
        },
        setPhone: {
            onOpen: {
                event: 'nav_signup_funnel',
                funnel: { current_step: 'Celular', name: 'cadastro_web' },
                user: { has_mdm: undefined },
            },
            onFieldBlur: ({ errorMessage }: { errorMessage?: string }) => ({
                event: 'nav_phone_number_feedback',
                funnel: { current_step: 'Celular', name: 'cadastro_web' },
                feedback_message: errorMessage || 'OK',
            }),
        },
        confirmToken: {
            onOpen: {
                event: 'nav_signup_funnel',
                funnel: { current_step: 'Token', name: 'cadastro_web' },
                user: { has_mdm: undefined },
            },
            onOpenResent: ({ itemText }: { itemText?: string }) => ({
                event: 'nav_signup_funnel',
                funnel: { current_step: 'Token (reenviar)', name: 'cadastro_web' },
                user: { has_mdm: undefined },
                item_text: itemText,
            }),
            onVerifyToken: ({ errorMessage }: { errorMessage?: string }) => ({
                event: 'nav_token_feedback',
                funnel: { current_step: 'Token', name: 'cadastro_web' },
                feedback_message: errorMessage || 'OK',
            }),
        },
        selectContact: {
            event: 'nav_signup_funnel',
            funnel: { current_step: 'Confirme que é você', name: 'cadastro_web' },
            user: { has_mdm: undefined },
        },
        success: {
            event: 'sign_up_success',
            funnel: { current_step: 'Cadastro concluído', name: 'cadastro_web' },
            user: { has_mdm: undefined },
        },
        confirmCpf: ({ errorMessage }: { errorMessage?: string }) => ({
            event: 'login_form_field_feedback',
            field_name: 'CPF',
            feedback_message: errorMessage || 'CPF não é válido',
        }),
    },
}
